import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { TriggerActionConfigModel, StateMachineStateConfigModel, StateMachineVariableConfig, VariableValueModel, StateMachineValueType, TriggerConditionKind, StateMachineVariableType } from '../../types';
import GuardianMessages from '../guardian-messages/guardian-messages.vue';
import { VariableSelection } from './trigger-condition-config';

@Component({
    components: {
        GuardianMessages
    }
})
export default class TriggerActionConfigComponent extends Vue {
    @Prop() action!: TriggerActionConfigModel;
    @Prop() states!: StateMachineStateConfigModel[];
    @Prop() variables!: StateMachineVariableConfig[];

    targetState: string = "";

    variablesTarget: VariableSelection[] = [];
    variableTarget: string = "";
    selectedVariableTarget: StateMachineVariableConfig | null = null;
    valueTypeTarget: StateMachineValueType | null = null;

    variablesSource: VariableSelection[] = [];
    variableSource: string = "";

    mailSubject: string = "";
    mailBody: string = "";

    script: string = "";

    @Watch("targetState")
    onTargetStateChanged(newState: string) {
        this.action.values = { "state": newState };
    }

    @Watch("variableTarget")
    onVariableTargetChanged(newVariable: string) {
        this.action.values = { "target": newVariable, "source": this.variableSource };
        const selectedVariable = this.variables.filter(variable => variable.name === newVariable)[0] ?? null;
        if (this.selectedVariableTarget !== selectedVariable) {
            this.selectedVariableTarget = selectedVariable;

            this.valueTypeTarget = selectedVariable !== null ? selectedVariable.valueType : null;
        }
    }

    @Watch("valueTypeTarget")
    onValueTypeLeftChanged(newValueType: TriggerConditionKind | null) {
        this.variablesSource = this.filterVariables(newValueType);
    }

    @Watch("variableSource")
    onVariableSourceChanged(newVariable: string) {
        this.action.values = { "target": this.variableTarget, "source": newVariable };
    }

    @Watch("mailSubject")
    onMailSubjectChanged(newMailSubject: string) {
        this.action.values = { "subject": newMailSubject, "body": this.mailBody };
    }

    @Watch("mailBody")
    onMailBodyChanged(newMailBody: string) {
        this.action.values = { "subject": this.mailSubject, "body": newMailBody };
    }

    @Watch("script")
    onScriptChanged(newScript: string) {
        this.action.values = { "script": newScript };
    }

    @Watch("variables")
    onVariablesChanged() {
        this.variablesTarget = this.variables.filter(v => v.type === StateMachineVariableType.GuardianVariable).map(v => new VariableSelection(v.name, v.name));
    }

    mounted() {
        this.onVariablesChanged();

        if (this.action.kind === "GoToState") {
            this.targetState = this.action.values["state"];
        } else if (this.action.kind === "SetStateVariable") {
            this.variableTarget = this.action.values["target"];
            this.variableSource = this.action.values["source"];
        } else if (this.action.kind === "SendMail") {
            this.mailSubject = this.action.values["subject"];
            this.mailBody = this.action.values["body"];
        } else if (this.action.kind === "Script") {
            this.script = this.action.values["script"];
        }
    }

    filterVariables(valueType: StateMachineValueType | null): VariableSelection[] {
        return this.variables.filter(v => (valueType == null) || (v.valueType === valueType)).map(v => new VariableSelection(v.name, v.name));
    }
}
